import React, { useState, useEffect } from 'react'
import {
  Outlet,
  useNavigate,
} from 'react-router-dom'
import TextField from '@material-ui/core/TextField'
import { useDispatch, useSelector } from 'react-redux'

import InputAdornment from '@material-ui/core/InputAdornment'
import Menu from '@material-ui/core/Menu'
import {
  Hidden,
  IconButton,
  Toolbar,
  makeStyles,
  Typography,
  Avatar,
} from '@material-ui/core'
import MenuIcon from '@material-ui/icons/Menu'
import InputIcon from '@material-ui/icons/Input'
import MenuList from '@material-ui/core/MenuList'
import MenuItem from '@material-ui/core/MenuItem'
import OnlineIcon from '../../icons/OnlineIcon'
import AlertIcon from '../../icons/AlertIcon'
import SearchIcon from '../../icons/SearchIcon'
import NavBar from './NavBar'
import {
  logout,
  getUserProfileInfo,
} from '../../app/slices/userSlice'
import {
  getUnseenNumber,
  selectorUnseenNotifications,
} from '../../app/slices/notificationSlice'
// import Loading from '../../components/Loading'
import { TOKEN_FIELD_STORAGE } from '../../api/index'

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: '#f5f5f5',
    display: 'flex',
    height: '100%',
    width: '100%',
    '& .MuiMenu-list': {
      overflow: 'hidden !important',
    },
  },
  wrapper: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'auto',
    [theme.breakpoints.up('lg')]: {
      paddingLeft: 268,
      paddingRight: 30,
    },
  },
  contentContainer: {
    display: 'flex',
    flex: '1 1 auto',
  },
  content: {
    flex: '1 1 auto',
    height: '100%',
    borderRadius: '20px',

  },
  searchbar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  searchbarIcons: {
    display: 'flex',
    alignItems: 'center',
    margin: '15px',
    position: 'relative',
  },
  alertIconWrap: {
    display: 'flex',
    alignItems: 'start',
    margin: '5px',
    position: 'relative',
    '@media (max-width: 960px)': {
      margin: '0px',
    },
  },
  alertIcon: {
    display: 'flex',
    alignItems: 'start',
    margin: '5px',
    position: 'relative',
    '@media (max-width: 960px)': {
      margin: '0px',
    },
  },
  onlineIcon: {
    display: 'flex',
    alignItems: 'start',
    margin: '5px',
    position: 'relative',
    '@media (max-width: 960px)': {
      margin: '0px',
    },
  },
  searchbarIcon: {
    margin: '12px',
  },
  AlertIconStatus: {
    width: '12px',
    height: '12px',
    backgroundColor: '#7bb872',
    display: 'inline-block',
    borderRadius: '50%',
    position: 'absolute',

  },
  OnlineIconStatus: {
    width: '12px',
    height: '12px',
    backgroundColor: '#7bb872',
    display: 'inline-block',
    borderRadius: '50%',
    position: 'absolute',
  },
  searchInput: {
    margin: '15px',
    width: '354px',
    height: '42px',
    transition: 'all 1s',
    '@media (max-width: 1289px)': {
      width: '100%',
    },
    '@media (max-width: 960px)': {
      width: '50%',
      height: '44px',

    },
  },
  searchField: {
    transition: 'all 1s',
    '&:focus': {
      backgroundColor: 'red',
    },
    '@media (max-width: 960px)': {
      height: '40px',
      '&:focus': {
        backgroundColor: 'red',
      },
    },
  },
  logout: {
    '@media (max-width: 960px)': {
      width: '1px !important',
      height: '1px',
      marginRight: '10px',
    },
  },
  menuRoot: {
    '@media (max-width: 960px)': {
      height: '54px',
      width: '79px',
      marginRight: '15px',
      marginBottom: '7px',
    },
  },
  menuItemRoot: {
    overflow: 'hidden !important',
  },
  focusInput: {
    '@media (max-width: 400px)': {
      transition: 'all 1s',
      width: '170%',
    },
  },
  myInput: {
    transition: 'all 1s',
  },
}))

const DashboardLayout = () => {
  const classes = useStyles()
  const unSeen = useSelector(selectorUnseenNotifications)
  const dispatch = useDispatch()
  const user = useSelector((state) => state.user)
  const isExaminer = user?.role?.roleId === 1
  const navigate = useNavigate()
  const [isMobileNavOpen, setMobileNavOpen] = useState(false)

  const [anchorEl, setAnchorEl] = React.useState(null)

  useEffect(() => {
    dispatch(getUserProfileInfo())
    if (window.innerWidth < 960) {
      document.getElementById('searchInput')?.setAttribute('placeholder', '...')
    } else if (window.innerWidth > 960) {
      document.getElementById('searchInput')?.setAttribute('placeholder', 'جست و جو کنید...')
    }

    if (isExaminer) dispatch(getUnseenNumber())
  }, [TOKEN_FIELD_STORAGE])

  console.log('unSeen', unSeen)

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <div className={classes.root}>
      <NavBar
        onMobileClose={() => setMobileNavOpen(false)}
        openMobile={isMobileNavOpen}
      />
      <div className={classes.wrapper}>

        <div className={classes.contentContainer}>

          <div className={classes.content}>
            <div style={{
              display: 'flex', flexFlow: 'row', justifyContent: 'space-between', alignItems: 'center',
            }}
            >
              <div style={{
                display: 'flex', flexFlow: 'row', justifyContent: 'start', alignItems: 'center',
              }}
              >
                <Hidden lgUp>
                  <IconButton
                    color="inherit"
                    onClick={() => setMobileNavOpen(true)}
                  >
                    <MenuIcon />
                  </IconButton>
                </Hidden>
                <div className={classes.searchbar}>
                  <TextField
                    className={classes.searchInput}
                    variant="outlined"
                    id="searchInput"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon />
                        </InputAdornment>
                      ),
                      style: { borderRadius: '50px' },
                      className: classes.searchField,
                      classes: { input: classes.myInput, focused: classes.focusInput },
                    }}
                  />
                </div>
              </div>
              <div className={classes.searchbarIcons}>

                <IconButton style={{ padding: '0px' }}>
                  <div className={classes.alertIconWrap}>
                    <AlertIcon
                      onClick={() => (user.role.roleId > 1 ? navigate('notifications/admin')
                        : navigate('notifications/user'))}
                      className={classes.alert}
                    />
                    {!!unSeen && unSeen !== 0 && <span className={classes.AlertIconStatus} />}
                  </div>
                </IconButton>

                <IconButton aria-controls="simple-menu" aria-haspopup="true" onClick={handleClick}>
                  <div className={classes.onlineIcon}>
                    <OnlineIcon />
                  </div>
                </IconButton>
                <Avatar alt="Remy Sharp" src={user?.profile?.photo?.url} />

                <div>
                  <Menu
                    style={{ overflow: 'hidden' }}
                    id="simple-menu"
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={handleClose}
                  >
                    {/* <Loading /> */}
                    <Toolbar>
                      <MenuList
                        classes={{ root: classes.menuRoot }}
                      >
                        <MenuItem
                          onClick={() => dispatch(logout())}
                        >
                          <IconButton className={classes.logout} color="inherit">
                            <InputIcon />
                          </IconButton>
                          <Typography variant="inherit">خروج</Typography>
                        </MenuItem>
                      </MenuList>
                    </Toolbar>
                  </Menu>
                </div>
              </div>
            </div>
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  )
}

export default DashboardLayout
